import React, { Component, Fragment } from 'react';
import {withRouter, Link} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import LoadingSpinner from '../loadingSpinner/';
import { numberFormat } from '../../common';

@withRouter
@inject('totoStore', 'dictStore')
@observer
export default class Result extends Component{

  componentDidMount() {
    this.props.totoStore.Result.init(this.props.match.params.resultId);
  }

  render() {
    const {isLoading, result, Result} = this.props.totoStore;
    const {getLang} = this.props.dictStore;
    return(
      !isLoading ? 
        <div className="toto-index-loading">
          <LoadingSpinner />
        </div> :
      <Fragment>
        {Result.data ? <TotoResult /> : <div className="toto-index-no">{getLang('INVALID_RESULT_ID')}</div>}
      </Fragment>
    )
  }
}

@inject('totoStore', 'dictStore', 'appStore')
@observer
class TotoResult extends Component { 

  selectCurrency = (e) => {
    this.props.totoStore.selectCurrency(e.target.value)
  }

  goBack = () => {
    this.props.appStore.history.goBack();
  }

	render() {

    const {getLang} = this.props.dictStore;
    const {currency, currencyId, current} = this.props.totoStore;
    const {data} = this.props.totoStore.Result;
    let number = 0;
    const keysAllloc = Object.keys(data.prize_alloc);

			return(
				<div className="toto-result">
          <div className="toto-result-currency clearfix">
              <a className="back" onClick={this.goBack} href="#">{getLang('BACK')}</a>
              <div className="fl_r">
                <label htmlFor="toto-currency">{getLang('SHOW_IN_CURRENCY')} </label>
                <select className="toto-index-currency" onChange={this.selectCurrency}>
                  {Object.keys(data.currency).map(id => 
                    <option key={id} value={data.currency[id].id} selected={data.currency[id].id == currencyId}>{data.currency[id].full_name}</option>
                  )}
                </select>
              </div>
          </div>
          <div className="toto-result-draw-data">
              <table className="toto-table">
                <thead>
                    <tr><th colSpan="2">{getLang("DRAW")} #R-{data.number}, {data.date.start} - {data.date.end}</th></tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="toto-result-draw-table-label">{getLang('POOL')}</td>
                        <td className="toto-result-draw-table-data">
                            <span id="toto-result-pool">{numberFormat(data.pool[currencyId], 2, ',', ' ')} {current.name}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="toto-result-draw-table-label">{getLang('PRIZE_FUND')}</td>
                        <td className="toto-result-draw-table-data">
                            <span id="toto-result-prize">{numberFormat(data.prize[currencyId], 2, ',', ' ')} {current.name}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="toto-result-draw-table-label">{getLang('BET_COUNT')}</td>
                        <td className="toto-result-draw-table-data">
                            <Link to={`/toto/cardsall/${data.id}`}>{data.cards_count}</Link>
                        </td>
                    </tr>
                    {keysAllloc.length ?
                      <tr>
                        <td className="toto-result-draw-table-label">{getLang('HAS_WON_OPTIONS')}</td>
                        <td className="toto-result-draw-table-data">
                            <Link to={`/toto/cards/${data.id}`}>{data.cards_win}</Link>
                        </td>
                      </tr>
                    : ''}
                    <tr>
                      <td className="toto-result-draw-table-label">{getLang('JACKPOT')}</td>
                      <td className="toto-result-draw-table-data">
                          <span id="toto-result-jackpot">{numberFormat(data.jackpot[currencyId], 2, ',', ' ')} {current.name}</span>
                      </td>
                    </tr>
                </tbody>
            </table>
          </div>
          {keysAllloc.length ? 
          <div className="toto-result-prize-allocation-cont clearfix">
              <table className="toto-table">
                  <thead>
                  <tr>
                    <th colSpan="4">{getLang('PRIZE_FUND_DISTRIBUTION')}</th>
                  </tr>
                  <tr>
                    <th>{getLang('GUESSED_RESULT')}</th>
                    <th>{getLang('OPTIONS_OF')}</th>
                    <th>{getLang('AMOUNT')}</th>
                    <th>{getLang('COMMENT')}</th>
                  </tr>
                  </thead>
                  <tbody>
                    {Object.keys(data.prize_alloc).map(el => 
                      <tr key={el}>
                        <td className="toto-result-table-guessed">{data.prize_alloc[el].guessed}</td>
                        <td className="toto-result-table-option">{data.prize_alloc[el].cards_win > 0 ? <Link to={`/toto/cards/${data.id}/${data.prize_alloc[el].guessed}`}>{data.prize_alloc[el].cards_win}</Link> : getLang('NO')}</td>
                        <td className="toto-result-table-amount">
                        <span>{numberFormat(data.prize_alloc[el].amount[currencyId], 2, ',', ' ')} {current.name}</span>
                        </td>
                        <td className="toto-result-table-comment">{data.prize_alloc[el].win == 0 ? getLang('TO_JACKPOT') : ''}</td>
                      </tr>
                    )} 
                  </tbody>
              </table>
            </div>
            : ''}
      <div className="toto-result-games-cont">
        <table className="toto-table" border="1">
            <thead>
                <tr>
                    <th rowSpan="2">№</th>
                    <th rowSpan="2">{getLang('DATE')}</th>
                    <th rowSpan="2" colSpan="2">{getLang('EVENT')}</th>
                    <th colSpan="3">{getLang('POOL_DISTRIBUTION')}</th>
                    <th rowSpan="2">{getLang('RESULT')}</th>
                </tr>
                <tr>
                    <th>1</th>
                    <th>X</th>
                    <th>2</th>
                </tr>
            </thead>
            <tbody>
              { Object.keys(data.sport).map(sid => {
                const league = data.sport[sid].league;
                return(
                  league.map(lid => 
                    <Fragment key={`tr_${lid}`}>
                      <tr>
                        <td className="toto-table-league-name" colSpan="10">{data.dict.sport[sid]}. {data.dict.league[lid]}</td>
                      </tr>
                      {data.league[lid].games.map((gid, idx) => {
                        ++number;
                        return(
                          <tr className="toto-index-game"  key={`td_${gid}`}>
                            <td className="toto-table-id">{number}</td>
                            <td className="toto-table-date">{data.games[gid].date}</td>
                            <td className="toto-table-cmd">{data.dict.cmd[data.games[gid].c1_id]}</td>
                            <td className="toto-table-cmd">{data.dict.cmd[data.games[gid].c2_id]}</td>
                            <td className="toto-table-pool-d">{data.games[gid].percent_1}%</td>
                            <td className="toto-table-pool-d">{data.games[gid].percent_X}%</td>
                            <td className="toto-table-pool-d">{data.games[gid].percent_2}%</td>
                            <td className="toto-table-score">{data.games[gid].score && data.games[gid].score != '{{ NO }}' ? getLang(data.games[gid].score) : getLang('NO')}</td>
                          </tr>
                       )
                      })}
                    </Fragment>
                ))}
              )}
            </tbody>
        </table>
    </div>
    <div className="toto-course-cont clearfix">
        <div className="fl_l toto-course-text">
            {getLang('MINIMUM_RATES_FOR_CURRENT_TOTO')}:
        </div>
        <div className="fl_l">
          <ul className="toto-course-list">
            {Object.keys(data.currency).map(id => 
              <li key={`cur_${id}`} className="fl_l">{data.currency[id].min} {data.currency[id].name}</li>
            )}
            </ul>
        </div>
      </div>
    </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/toto/result.jsx